module.exports = __webpack_public_path__ + "media/images/v2/default_img-1e3d099270c40dbaeb9fae679522c544.jpg";